import { render, staticRenderFns } from "./ProductPromotions.vue?vue&type=template&id=fa2c5884&scoped=true"
import script from "./ProductPromotions.vue?vue&type=script&lang=js"
export * from "./ProductPromotions.vue?vue&type=script&lang=js"
import style0 from "./ProductPromotions.vue?vue&type=style&index=0&id=fa2c5884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2c5884",
  null
  
)

export default component.exports